/* ═══════════════════════════════════════════════════════════════════════
   TAIBI · pagina collezione — il conteggio segue i filtri
   File nostro, non esiste in Dawn. Lo carica `sections/collezione-testata.liquid`.

   PERCHÉ ESISTE. Il conteggio è stato spostato dalla barra filtri alla
   testata (uno solo, non due). Ma il numero cambia a ogni filtraggio, e il
   filtraggio di Dawn è in AJAX: `facets.js` riscrive `#ProductCount` dentro
   `.facets-container` e non sa niente della nostra testata, che sta in
   un'altra sezione. Un numero calcolato in Liquid mentirebbe dal primo
   filtro — «25 prodotti» con dodici card sotto.

   ⚠️ NON si aggancia a un evento: `facets.js` non ne pubblica uno per il
   conteggio. Si guarda l'elemento che Dawn riscrive di sicuro.
   ⚠️ `#ProductCount` è anche la SORGENTE da cui Dawn legge il numero nella
   pagina scaricata: resta nel markup, spento dal CSS della sezione, non
   tolto. Toglierlo romperebbe il filtraggio (`sourceCount.innerHTML`, senza
   guardia).
   ═══════════════════════════════════════════════════════════════════════ */

(function () {
  var osservatore = null;

  function collega() {
    var sorgente = document.getElementById('ProductCount');
    var destino = document.getElementById('TaibiConteggio');
    if (!sorgente || !destino) return;

    var riquadro = destino.closest('.collezione-testata__conteggio');

    function copia() {
      destino.innerHTML = sorgente.innerHTML;
      if (riquadro) riquadro.classList.toggle('aggiornando', sorgente.classList.contains('loading'));
    }

    /* ⚠️ Si ricollega da zero a ogni chiamata invece di uscire se «già fatto»:
       nel customizer la sezione della griglia si ricarica e `#ProductCount`
       diventa un ELEMENTO NUOVO, mentre la nostra testata resta quella di
       prima. Una guardia sul destino avrebbe lasciato l'osservatore attaccato
       a un nodo che non è più in pagina. */
    if (osservatore) osservatore.disconnect();
    osservatore = new MutationObserver(copia);
    osservatore.observe(sorgente, {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });

    copia();
  }

  collega();
  document.addEventListener('shopify:section:load', collega);
})();
